import React, { ReactElement } from 'react';

import { BreedersSearch, NavigationMenu } from 'dogpark/components';

function NavigationCenterTools(): ReactElement {
  return (
    <>
      <NavigationMenu />
      <BreedersSearch />
    </>
  );
}

export default NavigationCenterTools;
